
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_16w7c_99",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_16w7c_133",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_16w7c_154",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_16w7c_157",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_16w7c_157",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_16w7c_160",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_16w7c_163",
  "sticky-cell": "awsui_sticky-cell_1spae_16w7c_166",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_16w7c_174",
  "has-selection": "awsui_has-selection_1spae_16w7c_174",
  "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_1spae_16w7c_177",
  "resize-divider": "awsui_resize-divider_1spae_16w7c_181",
  "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_1spae_16w7c_188",
  "sorting-icon": "awsui_sorting-icon_1spae_16w7c_207",
  "edit-icon": "awsui_edit-icon_1spae_16w7c_215",
  "header-cell-content": "awsui_header-cell-content_1spae_16w7c_221",
  "header-cell-content-expandable": "awsui_header-cell-content-expandable_1spae_16w7c_227",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_16w7c_279",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_16w7c_279",
  "header-cell-text": "awsui_header-cell-text_1spae_16w7c_293",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_16w7c_297",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_16w7c_303",
  "header-cell-descending": "awsui_header-cell-descending_1spae_16w7c_304",
  "is-visual-refresh": "awsui_is-visual-refresh_1spae_16w7c_314",
  "has-striped-rows": "awsui_has-striped-rows_1spae_16w7c_328",
  "sticky-cell-pad-inline-start": "awsui_sticky-cell-pad-inline-start_1spae_16w7c_334"
};
  